import normalize from "json-api-normalize";
import Attributes from "../models/Attributes";
import {objectToFormData} from "object-to-formdata";
import before from "vue-resource/src/http/interceptor/before";

export default {
  methods: {
    // Selected tags builder
    getSelectedTags: function (asset, tagStore) {
      const allTags = tagStore.tagsByCategory;

      return Object.keys(allTags).reduce((obj, key) => {
        const categoryTags = allTags[key].tags || [];
        const currentTagIds = asset.tag_ids || [];
        obj[key] = currentTagIds.filter(t => categoryTags.map(tt => tt.id).includes(t));
        return obj
      }, {})
    },

    // Save asset handling
    saveAsset: function (params, closeOnFinish = true) {
      if (this.saving) return;

      this.saving = true;

      const formData = objectToFormData(params, {nullsAsUndefineds: true}, new FormData(), 'asset');

      return this.$http.patch(`${this.url}/${this.asset.id}`, formData).then((fulfilled) => {
        const asset = this.buildAssetFromResponse(fulfilled.body);
        this.updateWithAsset(asset);
        if (closeOnFinish) {
          this.editing = false;
        }
        return fulfilled;
      }, rejected => {
        this.showErrorToast("Sorry, there was an error while updating this asset", rejected.body);
        return rejected;
      }).then(value => {
        this.saving = false;
        return value;
      })
    },

    // Asset response normalizer
    buildAssetFromResponse: function (assetResponse) {
      return normalize(assetResponse).get(Attributes.assetAttributes
        .concat(Attributes.prefixed('release_forms', Attributes.releaseFormAttributes)));
    },

    // Form data function to return an empty array if no elements present
    formDataArray: function (array) {
      return Array.isArray(array) && array.length > 0 ? array : [''];
    }
  },

  computed: {
    // Convert all selected tags to a single array
    formSelectedTags: function () {
      return Object.keys(this.selectedTags).reduce((array, key) => {
        return array.concat(this.selectedTags[key])
      }, []);
    },
  }
}